import { isAxiosError } from 'axios'

import { shipmentApiClient } from '../shipmentApiClient'

import { downloadTenantShipmentsCsvEndpoint } from './endpoint'
import { parseBlobErrorMessage } from './parseBlobErrorMessage'
import { parseContentDispositionFilename } from './parseContentDispositionFilename'
import { ShipmentCsvDownloadError } from './ShipmentCsvDownloadError'
import type { DownloadTenantShipmentsCsvParams, DownloadTenantShipmentsCsvResult } from './type'

export const downloadTenantShipmentsCsv = async (
  params: DownloadTenantShipmentsCsvParams
): Promise<DownloadTenantShipmentsCsvResult> => {
  const { tenantId, ...query } = params
  try {
    const res = await shipmentApiClient.get<Blob>(downloadTenantShipmentsCsvEndpoint(tenantId), {
      params: query,
      responseType: 'blob',
    })
    return {
      blob: res.data,
      filename: parseContentDispositionFilename(res.headers['content-disposition']),
    }
  } catch (error) {
    // WHY: Blob エラーは interceptor で正規化されないため、ここで BE の message と HTTP status を
    // 復元して ShipmentCsvDownloadError で投げ直す。onError が message 表示 / 401,403 の logout 分岐に使う。
    // 復元できない場合（network / 非JSON body）は元の error を再送出し、呼び出し側で汎用文言に倒す。
    const message = await parseBlobErrorMessage(error)
    const httpStatus = isAxiosError(error) ? error.response?.status : undefined
    if (message) throw new ShipmentCsvDownloadError(message, httpStatus)
    throw error
  }
}
